<template>
  <div class="finance-chart">
    <Bar :data="chartData" :options="chartOptions" />
  </div>
</template>

<script setup>
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js'
import { ref, onMounted } from 'vue'
import { getToken } from '@/utils/auth'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

const baseURL = process.env.VUE_APP_API_URL
const chartData = ref({
  labels: [],
  datasets: []
})

const chartOptions = {
  responsive: true,
  plugins: {
    legend: { position: 'top' },
    title: { display: true, text: 'Aylık Gelir-Gider Grafiği' }
  }
}

onMounted(async () => {
  try {
    const res = await fetch(`${baseURL}/admin/stats/finance`, {
      headers: { Authorization: `Bearer ${getToken()}` }
    })
    const data = await res.json()

    chartData.value = {
      labels: data.map(item => item.month),
      datasets: [
        {
          label: 'Gelir (₺)',
          backgroundColor: '#4caf50',
          data: data.map(item => item.total_income)
        },
        {
          label: 'Tercüman Gideri (₺)',
          backgroundColor: '#f44336',
          data: data.map(item => item.total_expense)
        },
        {
          label: 'Sabit Gider (₺)',
          backgroundColor: '#ff9800',
          data: data.map(item => item.fixed_expense)
        },
        {
          label: 'Net Kâr (₺)',
          backgroundColor: '#2196f3',
          data: data.map(item => item.net_profit)
        }
      ]
    }
  } catch (err) {
    console.error('Finans verisi alınamadı:', err)
  }
})
</script>

<style scoped>
.finance-chart {
  max-width: 900px;
  margin: 40px auto;
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.1);
}
</style>
